module.exports = new __parcel__URL__("github.d7b4299c.png").toString();